/* Smart Search — chip-based search with categorized autocomplete for TCG cards */
(function () {
  var TCG_CATALOG = {
    'Tipo MTG': [
      'Creature','Instant','Sorcery','Enchantment','Artifact','Planeswalker','Land',
      'Legendary','Tribal','Battle'
    ],
    'Tipo Pokémon': [
      'Fire','Water','Grass','Lightning','Psychic','Fighting','Darkness','Metal',
      'Dragon','Fairy','Colorless','Normal'
    ],
    'Color MTG': [
      'White','Blue','Black','Red','Green','Multicolor','Colorless'
    ],
    'Rareza': [
      'Common','Uncommon','Rare','Mythic','Mythic Rare','Special','Promo',
      'Unspecified','Secret Rare','Ultra Rare','Illustration Rare'
    ],
    'Acabado': [
      'Foil','Non-Foil','Etched','Surge','Confetti','Reverse Holo','Holo'
    ]
  };

  var COLLECTIONS = [
    { label: 'MTG Singles', handle: 'mtg-singles' },
    { label: 'Pokémon Singles', handle: 'pokemon-singles' },
    { label: 'Highlights on The Vault', handle: '💫-highlights-on-the-vault' },
    { label: 'Cartas más recientes', handle: '🔥-cartas-mas-recientes' },
    { label: 'Standard', handle: '🎴-standard' },
    { label: 'Producto Sellado', handle: 'producto-sellado' },
    { label: 'Accesorios', handle: 'accesorios' },
    { label: 'Board Games', handle: 'boardgames' },
    { label: 'Cool Lands', handle: '🏛️-cool-lands' },
    { label: 'Full Art Plains', handle: '🏛️-full-art-plains' },
    { label: 'Mountain', handle: '🏛️-mountain' },
    { label: 'Swamp', handle: '🏛️-swamp' }
  ];

  var CATEGORY_ICONS = {
    'Tipo MTG': '🃏',
    'Tipo Pokémon': '⚡',
    'Color MTG': '🎨',
    'Rareza': '✨',
    'Acabado': '🌟',
    'Colección': '📦',
    'Búsqueda': '🔍'
  };

  var CATEGORY_CONTEXT = {
    'Tipo MTG': 'mtg',
    'Color MTG': 'mtg',
    'Tipo Pokémon': 'pokemon'
  };

  var TERM_LOOKUP = {};
  Object.keys(TCG_CATALOG).forEach(function (cat) {
    TCG_CATALOG[cat].forEach(function (item) {
      TERM_LOOKUP[item.toLowerCase()] = { category: cat, value: item };
    });
  });

  function initSmartSearch(container) {
    var form = container.querySelector('form[role="search"]');
    var input = container.querySelector('input[type="search"]');
    if (!form || !input) return;

    // Se guarda ANTES de que nada lo toque: `updatePlaceholder` corre durante el
    // arranque, así que capturarlo más abajo devolvía el texto ya pisado.
    // En el hero de la landing ese placeholder no es decoración: "…o pega tu
    // lista completa" es la única forma en que alguien descubre la multibúsqueda
    // (ADR 153). Borrarlo era borrar la funcionalidad.
    var placeholderOriginal = input.getAttribute('placeholder') || 'Busca por nombre, tipo, set, color...';

    var chips = [];
    var activeExpand = null;
    var highlightIdx = -1;
    var currentSuggestions = [];
    var predictiveDiv = container.querySelector('.predictive-search');

    var chipsContainer = document.createElement('div');
    chipsContainer.className = 'smart-search__chips';
    // `.field` es la caja de Dawn; `.vault-buscador__campo` es la del componente
    // del ADR 153. Sin el segundo, esto era `null` y reventaba aquí mismo: los
    // chips no aparecían en el hero y nada lo decía.
    var fieldDiv = input.closest('.field') || input.closest('.vault-buscador__campo');
    if (!fieldDiv) return;
    fieldDiv.insertBefore(chipsContainer, input);
    fieldDiv.classList.add('smart-search-field');

    var smartSearchParent = fieldDiv.closest('form').parentNode;
    var suggestionsActive = false;
    var blockNextEnter = false;

    // When we consumed Enter in keydown, block Shopify's keyup Enter from navigating
    var predictiveComponent = container.querySelector('predictive-search');
    if (predictiveComponent) {
      ['keyup', 'keydown'].forEach(function (evt) {
        predictiveComponent.addEventListener(evt, function (e) {
          if (blockNextEnter && (e.key === 'Enter' || e.code === 'Enter')) {
            e.stopImmediatePropagation();
            e.preventDefault();
            if (evt === 'keyup') blockNextEnter = false;
          }
        }, true);
      });
    }

    function deselectProducts() {
      if (!predictiveComponent) return;
      var sel = predictiveComponent.querySelector('[aria-selected="true"]');
      if (sel) sel.setAttribute('aria-selected', 'false');
    }

    // Persistent "+" button for showing all filters
    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'smart-search__add-btn';
    addBtn.textContent = '+';
    addBtn.title = 'Agregar filtro';
    addBtn.style.display = 'none';
    fieldDiv.insertBefore(addBtn, input);

    var suggestionsEl = document.createElement('div');
    suggestionsEl.className = 'smart-search__suggestions';
    suggestionsEl.style.display = 'none';
    if (predictiveDiv) {
      predictiveDiv.parentNode.insertBefore(suggestionsEl, predictiveDiv);
    }

    // --- Hydrate chips from URL ---
    (function hydrateFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var q = params.get('q');
      if (!q) {
        // Sin término no hay nada que hidratar, así que el campo se queda con SU
        // placeholder: el del hero anuncia la multibúsqueda y esta línea lo pisaba.
        input.setAttribute('placeholder', placeholderOriginal);
        smartSearchParent.classList.add('smart-search-active');
        return;
      }

      var words = q.split(/\s+/);
      var remaining = [];
      var contextTerms = ['mtg', 'pokemon'];

      words.forEach(function (word) {
        var lower = word.toLowerCase();
        if (contextTerms.indexOf(lower) !== -1) return;
        var lookup = TERM_LOOKUP[lower];
        if (lookup) {
          chips.push({ category: lookup.category, value: lookup.value });
        } else {
          remaining.push(word);
        }
      });

      input.value = remaining.length ? remaining.join(' ') : '';
      if (chips.length) renderChips();
      updatePlaceholder();
      smartSearchParent.classList.add('smart-search-active');
    })();

    // --- Render chips ---
    function renderChips() {
      chipsContainer.innerHTML = '';
      chips.forEach(function (chip, idx) {
        var el = document.createElement('span');
        el.className = 'smart-search__chip';
        if (chip.category !== 'Búsqueda' && TCG_CATALOG[chip.category]) {
          el.classList.add('smart-search__chip--expandable');
        }
        el.innerHTML =
          '<span class="smart-search__chip-cat">' + (CATEGORY_ICONS[chip.category] || '🏷️') + '</span>' +
          '<span class="smart-search__chip-label">' + chip.value + '</span>' +
          '<button type="button" class="smart-search__chip-remove" data-idx="' + idx + '" aria-label="Quitar ' + chip.value + '">&times;</button>';

        var labelEl = el.querySelector('.smart-search__chip-label');
        var catEl = el.querySelector('.smart-search__chip-cat');
        if (chip.category !== 'Búsqueda' && TCG_CATALOG[chip.category]) {
          var expandClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggleExpand(idx);
          };
          labelEl.addEventListener('click', expandClick);
          catEl.addEventListener('click', expandClick);
        }

        chipsContainer.appendChild(el);
      });

      chipsContainer.style.display = chips.length ? 'flex' : 'none';
      addBtn.style.display = chips.length ? '' : 'none';

      chipsContainer.querySelectorAll('.smart-search__chip-remove').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          closeExpand();
          chips.splice(parseInt(this.dataset.idx), 1);
          renderChips();
          updatePlaceholder();
          submitSearch();
          input.focus();
        });
      });
    }

    // --- Expand dropdown for a chip's category ---
    function toggleExpand(chipIdx) {
      if (activeExpand === chipIdx) { closeExpand(); return; }
      closeExpand();
      activeExpand = chipIdx;

      var chip = chips[chipIdx];
      var cat = chip.category;
      var items = TCG_CATALOG[cat];
      if (!items) return;

      var activeValues = chips
        .filter(function (c) { return c.category === cat; })
        .map(function (c) { return c.value.toLowerCase(); });

      var dropdown = document.createElement('div');
      dropdown.className = 'smart-search__expand';
      dropdown.innerHTML = '<div class="smart-search__expand-title">' +
        (CATEGORY_ICONS[cat] || '') + ' ' + cat + '</div>';

      var list = document.createElement('div');
      list.className = 'smart-search__expand-list';

      items.forEach(function (item) {
        var isActive = activeValues.indexOf(item.toLowerCase()) !== -1;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'smart-search__expand-item';
        if (isActive) btn.classList.add('smart-search__expand-item--active');
        btn.textContent = item;
        btn.addEventListener('mousedown', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (isActive) {
            for (var i = chips.length - 1; i >= 0; i--) {
              if (chips[i].category === cat && chips[i].value.toLowerCase() === item.toLowerCase()) {
                chips.splice(i, 1);
                break;
              }
            }
          } else {
            chips.push({ category: cat, value: item });
          }
          closeExpand();
          renderChips();
          submitSearch();
        });
        list.appendChild(btn);
      });

      dropdown.appendChild(list);
      var chipEl = chipsContainer.children[chipIdx];
      if (chipEl) {
        chipEl.style.position = 'relative';
        chipEl.appendChild(dropdown);
      }
    }

    function closeExpand() {
      activeExpand = null;
      var existing = chipsContainer.querySelectorAll('.smart-search__expand');
      existing.forEach(function (el) { el.remove(); });
    }

    // --- "+" button: show all categories as suggestions ---
    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (suggestionsEl.style.display === 'block' && !input.value.trim()) {
        hideSuggestions();
        return;
      }
      showAllCategories();
      input.focus();
    });

    function showAllCategories() {
      var activeValues = chips.map(function (c) { return c.value.toLowerCase(); });
      var all = [];
      Object.keys(TCG_CATALOG).forEach(function (category) {
        TCG_CATALOG[category].forEach(function (item) {
          if (activeValues.indexOf(item.toLowerCase()) === -1) {
            all.push({ category: category, value: item });
          }
        });
      });
      COLLECTIONS.forEach(function (col) {
        all.push({ category: 'Colección', value: col.label, handle: col.handle });
      });
      currentSuggestions = all.slice(0, 20);
      highlightIdx = -1;
      showSuggestions(currentSuggestions);
    }

    // --- Placeholder ---
    function updatePlaceholder() {
      input.setAttribute('placeholder', chips.length ? '' : placeholderOriginal);
    }

    // --- Add chip + auto-search ---
    function addChip(category, value, handle) {
      if (category === 'Colección' && handle) {
        var searchTerms = chips.map(function (c) { return c.value; });
        var freeText = input.value.trim();
        if (freeText) searchTerms.push(freeText);
        var url = '/collections/' + encodeURIComponent(handle);
        if (searchTerms.length) {
          url += '?q=' + encodeURIComponent(searchTerms.join(' '));
        }
        window.location.href = url;
        return;
      }
      var exists = chips.some(function (c) { return c.value.toLowerCase() === value.toLowerCase(); });
      if (exists) return;
      chips.push({ category: category, value: value });
      input.value = '';
      renderChips();
      hideSuggestions();
      updatePlaceholder();
      submitSearch();
      input.focus();
    }

    // --- Build query from chips ---
    function buildQuery() {
      var terms = [];
      var contexts = {};
      chips.forEach(function (c) {
        terms.push(c.value);
        var ctx = CATEGORY_CONTEXT[c.category];
        if (ctx) contexts[ctx] = true;
      });
      Object.keys(contexts).forEach(function (ctx) {
        terms.push(ctx);
      });
      var freeText = input.value.trim();
      if (freeText) terms.push(freeText);
      return terms.join(' ');
    }

    // --- Auto-submit search ---
    function submitSearch() {
      var query = buildQuery();
      if (!query) return;
      input.style.color = 'transparent';
      input.style.caretColor = 'transparent';
      input.value = query;
      form.submit();
    }

    function triggerPredictiveWithChips() {
      var fullQuery = buildQuery();
      var predictiveComponent = container.querySelector('predictive-search');
      if (predictiveComponent && fullQuery) {
        predictiveComponent.searchTerm = fullQuery;
        predictiveComponent.cachedResults = {};
        predictiveComponent.getSearchResults(fullQuery);
      } else if (predictiveComponent && !fullQuery) {
        predictiveComponent.close(true);
      }
    }

    // --- Suggestions ---
    function getSuggestions(query) {
      if (!query || query.length < 2) return [];
      var q = query.toLowerCase();
      var activeValues = chips.map(function (c) { return c.value.toLowerCase(); });
      var results = [];
      Object.keys(TCG_CATALOG).forEach(function (category) {
        TCG_CATALOG[category].forEach(function (item) {
          if (item.toLowerCase().indexOf(q) !== -1 && activeValues.indexOf(item.toLowerCase()) === -1) {
            results.push({ category: category, value: item });
          }
        });
      });
      COLLECTIONS.forEach(function (col) {
        if (col.label.toLowerCase().indexOf(q) !== -1 || col.handle.toLowerCase().indexOf(q) !== -1) {
          results.push({ category: 'Colección', value: col.label, handle: col.handle });
        }
      });
      return results.slice(0, 10);
    }

    function showSuggestions(suggestions) {
      suggestionsEl.innerHTML = '';
      if (!suggestions.length) { hideSuggestions(); return; }

      var title = document.createElement('div');
      title.className = 'smart-search__suggestions-title';
      title.textContent = 'Filtrar por categoría';
      suggestionsEl.appendChild(title);

      var list = document.createElement('div');
      list.className = 'smart-search__suggestions-list';

      suggestions.forEach(function (item, idx) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'smart-search__suggestion-chip';
        if (item.category === 'Colección') {
          btn.classList.add('smart-search__suggestion-chip--collection');
        }
        if (idx === highlightIdx) {
          btn.classList.add('smart-search__suggestion-chip--highlighted');
        }
        btn.innerHTML = '<span class="smart-search__suggestion-chip-icon">' +
          (CATEGORY_ICONS[item.category] || '🏷️') + '</span>' +
          '<span>' + item.value + '</span>' +
          '<span class="smart-search__suggestion-chip-cat">' + item.category + '</span>';
        btn.addEventListener('mousedown', function (e) {
          e.preventDefault();
          e.stopPropagation();
          addChip(item.category, item.value, item.handle);
        });
        list.appendChild(btn);
      });

      suggestionsEl.appendChild(list);
      suggestionsEl.style.display = 'block';
      suggestionsActive = true;
    }

    function hideSuggestions() {
      suggestionsEl.style.display = 'none';
      suggestionsActive = false;
      highlightIdx = -1;
      currentSuggestions = [];
    }

    function updateHighlight() {
      var btns = suggestionsEl.querySelectorAll('.smart-search__suggestion-chip');
      btns.forEach(function (btn, i) {
        btn.classList.toggle('smart-search__suggestion-chip--highlighted', i === highlightIdx);
      });
      if (highlightIdx >= 0 && btns[highlightIdx]) {
        btns[highlightIdx].scrollIntoView({ block: 'nearest' });
      }
    }

    // --- Events ---
    function hasSuggestions() {
      return currentSuggestions.length > 0 && suggestionsEl.style.display === 'block';
    }

    // Hide predictive search when our suggestions are visible
    function syncPredictive() {
      var predictiveComponent = container.querySelector('predictive-search');
      if (!predictiveComponent) return;
      if (hasSuggestions()) {
        predictiveComponent.close(false);
      }
    }

    function showHints() {
      suggestionsEl.innerHTML = '';

      /*
       * La instrucción de pegar una lista SOLO sale donde pegar una lista hace
       * algo. El modo lista lo pinta únicamente la variante `hero` del buscador
       * (ver `vault-buscador.liquid`): en la barra anclada de las colecciones no
       * hay textarea ni detección, así que anunciarlo ahí sería enseñar un truco
       * que no funciona.
       */
      var pegarLista = container.dataset.variante === 'hero'
        ? '<div class="smart-search__hints-row smart-search__hints-row--lista">' +
            '<span class="smart-search__hints-keys">Pega</span> tu lista completa y la cotizamos' +
          '</div>'
        : '';

      var hints = document.createElement('div');
      hints.className = 'smart-search__hints';
      hints.innerHTML =
        '<div class="smart-search__hints-title">Busca en The Vault</div>' +
        '<div class="smart-search__hints-row"><span class="smart-search__hints-keys">Escribe</span> nombre de carta, set o tipo</div>' +
        pegarLista +
        '<div class="smart-search__hints-row"><span class="smart-search__hints-keys">← →</span> navega filtros</div>' +
        '<div class="smart-search__hints-row"><span class="smart-search__hints-keys">↑ ↓</span> navega productos</div>' +
        '<div class="smart-search__hints-row"><span class="smart-search__hints-keys">Enter</span> selecciona</div>' +
        '<div class="smart-search__hints-cats">' +
          '<span class="smart-search__hints-cat">🃏 Tipo</span>' +
          '<span class="smart-search__hints-cat">🎨 Color</span>' +
          '<span class="smart-search__hints-cat">✨ Rareza</span>' +
          '<span class="smart-search__hints-cat">🌟 Acabado</span>' +
          '<span class="smart-search__hints-cat">📦 Colección</span>' +
        '</div>';

      suggestionsEl.appendChild(hints);
      suggestionsEl.style.display = 'block';
      suggestionsActive = false;
    }

    input.addEventListener('focus', function () {
      if (!this.value.trim() && !chips.length) {
        showHints();
      }
    });

    input.addEventListener('input', function () {
      closeExpand();
      var query = this.value.trim();
      var suggestions = getSuggestions(query);
      currentSuggestions = suggestions;
      highlightIdx = -1;
      if (suggestions.length) {
        showSuggestions(suggestions);
        syncPredictive();
      } else if (!query && !chips.length) {
        showHints();
      } else {
        hideSuggestions();
      }
    });

    // Left/Right = navigate filters (deselect products)
    // Up/Down = navigate products (deselect filters)
    // Enter = act on whichever is selected
    input.addEventListener('keydown', function (e) {
      if (hasSuggestions()) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          deselectProducts();
          highlightIdx = (highlightIdx + 1) % currentSuggestions.length;
          updateHighlight();
          return;
        }
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          deselectProducts();
          highlightIdx = highlightIdx <= 0 ? currentSuggestions.length - 1 : highlightIdx - 1;
          updateHighlight();
          return;
        }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          // Deselect our filter, let Shopify handle product navigation
          highlightIdx = -1;
          updateHighlight();
          return;
        }
        if (e.key === 'Escape') {
          hideSuggestions();
          return;
        }
        if (e.key === 'Enter' && highlightIdx >= 0) {
          e.preventDefault();
          e.stopImmediatePropagation();
          blockNextEnter = true;
          var sel = currentSuggestions[highlightIdx];
          addChip(sel.category, sel.value, sel.handle);
          return;
        }
      }

      // Enter with text but no suggestion selected — add as free text chip or submit
      if (e.key === 'Enter' && this.value.trim()) {
        if (chips.length > 0) {
          e.preventDefault();
          e.stopImmediatePropagation();
          chips.push({ category: 'Búsqueda', value: this.value.trim() });
          this.value = '';
          renderChips();
          hideSuggestions();
          updatePlaceholder();
          submitSearch();
          return;
        }
      }

      // Enter with no text but with chips — submit
      if (e.key === 'Enter' && !this.value.trim() && chips.length > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        submitSearch();
        return;
      }

      // Backspace removes last chip
      if (e.key === 'Backspace' && !this.value && chips.length) {
        closeExpand();
        chips.pop();
        renderChips();
        updatePlaceholder();
        submitSearch();
      }
    }, true);

    form.addEventListener('submit', function () {
      if (chips.length) {
        input.style.color = 'transparent';
        input.style.caretColor = 'transparent';
        input.value = buildQuery();
      }
    });

    document.addEventListener('click', function (e) {
      if (!chipsContainer.contains(e.target) && e.target !== addBtn) {
        closeExpand();
      }
      if (!suggestionsEl.contains(e.target) && e.target !== input && e.target !== addBtn) {
        hideSuggestions();
      }
    });
  }

  /*
   * Se engancha a cualquier buscador de la casa, no solo a la barra anclada.
   *
   * `initSmartSearch` siempre supo trabajar con cualquier contenedor que traiga
   * su form y su input — lo único que lo ataba al header era este arranque. Al
   * volverse componente el buscador (ADR 153), el hero del home pedía los chips
   * y se quedaba sin ellos: escribías "foil" y no salía nada, cuando en
   * colecciones sí. Esto es lo que lo arregla.
   */
  function boot() {
    var targets = document.querySelectorAll('[data-vault-buscador], .header-search-always-visible');
    Array.prototype.forEach.call(targets, function (target) {
      /*
       * Una envoltura no es un buscador. Desde que la barra anclada monta el
       * componente, `.header-search-always-visible` CONTIENE un
       * `[data-vault-buscador]` y los dos selectores apuntaban al mismo campo:
       * se inicializaba dos veces y salían dos juegos de chips y dos paneles de
       * instrucciones sobre el mismo input.
       */
      if (target.querySelector('[data-vault-buscador]')) return;
      if (target.dataset.smartSearchInit) return;
      target.dataset.smartSearchInit = 'true';
      try {
        initSmartSearch(target);
      } catch (e) {
        // Un buscador que no cumpla el contrato no puede dejar sin chips a los
        // demás: antes, una excepción aquí cortaba el recorrido entero.
        console.error('Smart Search no pudo iniciar en un contenedor:', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
